module.exports = __webpack_public_path__ + "static/media/darkBackground.92e8db15.png";